import { api } from './base-api';
import {
  PaginatedSaques,
  SaqueDetail,
  SaquesFilters,
} from '../../types/saque';

const cleanParams = (filters: Partial<SaquesFilters>) => {
  const result: Record<string, string | number> = {};
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '') continue;
    result[key] = value as string | number;
  }
  return result;
};

export interface ListSaquesParams extends Partial<SaquesFilters> {
  page?: number;
  limit?: number;
}

export const saquesApi = {
  async list(params: ListSaquesParams = {}): Promise<PaginatedSaques> {
    const { data } = await api.get<PaginatedSaques>('/admin/saques', {
      params: cleanParams(params),
    });
    return data;
  },

  async detail(id: string): Promise<SaqueDetail> {
    const { data } = await api.get<SaqueDetail>(`/admin/saques/${id}`);
    return data;
  },

  async confirm(id: string): Promise<SaqueDetail> {
    const { data } = await api.patch<SaqueDetail>(
      `/admin/saques/${id}/confirmar`,
    );
    return data;
  },

  async refuse(id: string): Promise<SaqueDetail> {
    const { data } = await api.patch<SaqueDetail>(
      `/admin/saques/${id}/recusar`,
    );
    return data;
  },
};
